import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";
import QRDETAILS from "../../assets/images/patientQR.png"
import LOGO from "../../assets/images/logos/logoImuno.png"
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {  getPatientDetailsByIdNoAuth, qrGenerationIsLoading } from "../../slices/QRCode";
import { dateFormater } from "../../utils/common/utils";
import InitialsAvatar from "../../components/common/InitialsAvatar";
import SkeletonLoader from "../../../utilites/SkeltonLoader";

export default function PatientInfoCard() {
    const { id } = useParams();
    const navigate = useNavigate()
    const isLoading = useSelector(qrGenerationIsLoading)
    const LoginData = useSelector((state) => state.loginData);
    const user = LoginData?.token
    const {role_id,role_slug} = LoginData

    const dispatch = useDispatch()
    const [qrDetails, setQrdetails] = useState(null)
    const fetchQrdetails = async () => {
        try {
            const patientDetailsResponse = await dispatch(getPatientDetailsByIdNoAuth(id)).unwrap();
            const patientDetails = patientDetailsResponse?.data;
            setQrdetails(patientDetails)
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        fetchQrdetails()
    }, [])
    return (
        <div>
            <div className="bg-white">
                <img className="p-3" src={LOGO} />
            </div>
            <div className="min-h-screen bg-gray-100 p-6">
                <Card className="max-w-6xl mx-auto shadow-lg rounded-xl">
                    {qrDetails && Object.keys(qrDetails)?.length > 0 ?
                        <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start p-6">
                            <div className="md:col-span-2">
                                <div className="flex items-center space-x-4 mb-6">
                                    {!isLoading
                                        ? <InitialsAvatar
                                            bgcolor="#D5DCF4"
                                            color="#3571FF"
                                            size={50}
                                            fontSize={20}
                                            fontWeight={700}
                                        >
                                            {qrDetails?.patient_information?.name}
                                        </InitialsAvatar>
                                        : <Skeleton variant="circular" width={40} height={40} />}
                                    {!isLoading ?
                                        < div >
                                            {/* <p className="text-lg font-semibold">{qrDetails?.patient_information?.name}</p> */}
                                            <p className="text-sm text-gray-500">{qrDetails?.patient_information?.patient_initials}</p>
                                        </div> : <div>
                                            <p className="text-lg font-semibold"> <SkeletonLoader height={16} width={200} /></p>
                                            <p className="text-sm text-gray-500"> <SkeletonLoader height={16} width={200} /></p>
                                        </div>
                                    }
                                </div>
                                {!isLoading
                                    ? <div className="text-sm text-gray-700 space-y-2">
                                        <p className="flex">
                                            <span className="font-semibold flex-1">Patient Body Weight:</span>
                                            <span className="flex-1 flex gap-2 !items-baseline"> <span>{qrDetails?.patient_information?.body_weight ?? <SkeletonLoader height={16} width={200} />}</span><span>kg</span></span>

                                        </p>
                                        <p className="flex">
                                            <span className="font-semibold flex-1">Disease Indication:</span>
                                            <span className="flex-1">  {qrDetails?.patient_information?.disease ?? <SkeletonLoader height={16} width={200} />}</span>

                                        </p>
                                        <p className="flex">
                                            <span className="font-semibold flex-1">Date of Birth:</span>
                                            <span className="flex-1">  {dateFormater(qrDetails?.patient_information?.dob) ?? <SkeletonLoader height={16} width={200} />}</span>

                                        </p>
                                        <p className="flex">
                                            <span className="font-semibold flex-1">Hospital Name:</span>
                                            <span className="flex-1">  {qrDetails?.patient_information?.hospital ?? <SkeletonLoader height={16} width={200} />}</span>

                                        </p>
                                        <p className="flex">
                                            <span className="font-semibold flex-1">Hospital Patient ID:</span>
                                            <span className="flex-1">  {qrDetails?.hospital_patient_id ?? <SkeletonLoader height={16} width={200} />}</span>

                                        </p>
                                        <p className="flex">
                                            <span className="font-semibold flex-1">Ship & Store:</span>
                                            <span className="flex-1">   2-8 degree celsius</span>

                                        </p>
                                        <p className="flex">
                                            <span className="font-semibold flex-1">No of Bags:</span>
                                            <span className="flex-1">  {parseInt(qrDetails?.number_of_bags) ?? <SkeletonLoader height={16} width={200} />}</span>

                                        </p>
                                    </div>
                                    : <div className="text-sm text-gray-700 space-y-2">
                                        <p className="flex">
                                            <span className="font-semibold flex-1"><SkeletonLoader height={16} width={200} rowCount={7} /></span>
                                            <span className="flex-1 flex gap-2 !items-baseline"> <span>  <SkeletonLoader height={16} width={200} rowCount={7} /></span></span>
                                        </p>
                                    </div>}
                                <hr className="mt-4 mb-4" />
                                {!isLoading
                                    ? <p className="mt-4 text-sm">
                                        {user && (role_id == 5 || role_slug == 'project-manager')
                                            ? <span> Click <a onClick={() => navigate(`/phases/phase-details/${qrDetails?.patient_information?.phase_id}/patient-details/${qrDetails?.patient_information?.id}/inbound-form/${id}`)} className="!text-blue-600 !underline cursor-pointer">here</a> and know all the updates related to the patient.</span>
                                            : user
                                                ? <span> Click <a onClick={() => navigate(`/bmr/logistics-management/in-bound/view/${id}/${qrDetails?.patient_information?.id}`)} className="!text-blue-600 !underline cursor-pointer">here</a> and know all the updates related to the patient.</span>
                                                : <span> Click <a onClick={() => navigate('/login', { state: { from: (role_id == 5 || role_slug == 'project-manager') ? `/phases/phase-details/${qrDetails?.patient_information?.phase_id}/patient-details/${qrDetails?.patient_information?.id}/inbound-form/${id}`:`/bmr/logistics-management/in-bound/view/${id}/${qrDetails?.patient_information?.id}`, message: 'Please log in first.' } })} className="!text-blue-600 !underline cursor-pointer">here</a> to login, and know all the updates related to the patient.</span>
                                        }
                                    </p>
                                    : <SkeletonLoader height={16} width={400} />}
                            </div>
                            <div className="flex justify-center items-center">
                                <img
                                    src={QRDETAILS}// Replace this with your local image or a proper public path
                                    alt="Medical Illustration"
                                    className="w-full h-auto"
                                />
                            </div>
                        </CardContent> : <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                                minHeight: '300px' // Adjust this value as needed
                            }}
                        >
                            <Typography variant="body1">No QR Found</Typography>
                        </Box>}
                </Card>
            </div>
        </div >
    );
}